/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import urls from "../../api/urls";
import NormalAPI from "../../api";
import { capitalize } from "../../utils";

const { GET_HUB_LISTS, GET_CP_LIST, NEW_GET_CP_LIST } = urls;
export const getHubList = async () => {
  const response = await NormalAPI.Api(GET_HUB_LISTS).getWithHeader();
  if (response?.status) {
    return response?.response?.data?.map((val) => ({
      label: capitalize(val?.premiseName),
      value: val?.premiseId,
    })) || [];
  }
  return [];
};

export const getAllCPList = async () => {
  const response = await NormalAPI.Api(NEW_GET_CP_LIST).getWithHeader();
  if (response?.status) {
    return response?.response?.data?.map((val) => ({
      label: capitalize(val?.premiseName),
      value: val?.premiseId,
    })) || [];
  }
  return [];
};

export const getHubCPList = async (hubId) => {
  const response = await NormalAPI.Api(`${GET_CP_LIST}${hubId}?page=0&size=1000`).getWithHeader();
  if (response?.status) {
    return response?.response?.data?.data?.map((val) => ({
      label: capitalize(val?.cpName),
      value: val?.cpId,
    })) || [];
  }
  return [];
}; 
